export default "__VITE_ASSET__DB0cpo7k__"